<template>
    <el-dialog title="New Building" :visible.sync="$parent.showForm" width="600px">
        <el-form ref="form" :model="form" :rules="rules">
            <el-row>
                <el-col>
                    <el-form-item prop="supplier_id">
                        <el-select v-model="form.supplier_id" placeholder="Supplier wählen" remote default-first-option>
                            <el-option
                                v-for="supplier in get_suppliers"
                                :key="supplier.id"
                                :label="supplier.supplier_name"
                                :value="supplier.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="16">
                    <el-form-item label="Street" prop="street">
                        <el-input v-model="form.street" auto-complete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="house_number" label="Number">
                        <el-input v-model="form.house_number" auto-complete="off" type="number"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="Suffix">
                        <el-input v-model="form.suffix" auto-complete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="4">
                    <el-form-item label="Default panel price">
                        <el-input v-model="form.default_panel_price" auto-complete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                    <h3 style="font-size: 16px">Felder und Panels Hinzufügen</h3>
                </el-col>
            </el-row>
            <el-row
                v-for="(field, index) in form.fields"
                :key="index">
                <el-col :span="12">
                    <el-form-item
                            :prop="'fields.' + index + '.panels_number'"
                            :label="'Field ' + (index + 1)">
                        <el-input-number
                                placeholder="Number of panels"
                                v-model="field.panels_number"
                                :min="1"
                                type="number" />
                    </el-form-item>
                </el-col>
                <el-col :span="2" :offset="1">
                    <el-button size="mini" type="primary" @click="addBuildingField()" plain>
                        Hinzufügen
                    </el-button>
                </el-col>
                <el-col :span="1" :offset="1">
                    <el-button size="mini" type="danger" @click.prevent="removeBuildingField(index)" plain>
                        Delete
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('form')">
                Bestätigen
                <i v-if="formSubmitted" class="el-icon-loading"></i>
            </el-button>
            <el-button @click="closeForm">Abbrechen</el-button>
        </span>
    </el-dialog>
</template>


<script>
    /* eslint-disable no-console,no-plusplus,no-restricted-syntax */
    import { mapGetters } from 'vuex';
    import api from '../../../util/api';

    export default {
        name: 'BuildingForm',
        data () {
            return {
                formLabelWidth: '120px',
                dialogFormVisible: false,
                formSubmitted: false,
                rules: {
                    supplier_id: [
                        { required: true, message: 'Please select supplier', trigger: 'change' },
                    ],
                    street: [
                        { required: true, message: 'Street is missing', trigger: 'change' },
                    ],
                    house_number: [
                        { required: true, message: 'Number is missing', trigger: 'change' },
                    ],
                    fields: [
                        { type: 'array', required: true, message: 'Please add at least one field', trigger: 'blur' },
                    ],
                },
                form: {
                    supplier_id: '',
                    street: '',
                    house_number: '',
                    suffix: '',
                    default_panel_price: '100',
                    fields: [
                        { panels: '' },
                    ],
                },
            };
        },
        computed: {
            ...mapGetters(['get_suppliers']),
        },
        props: {
            formVisible: {
                type: Boolean,
                required: true,
            },
            supplierId: {
                required: false,
            },
        },
        methods: {
            addBuildingField () {
                this.form.fields.push({ panels: '' });
            },
            removeBuildingField (index) {
                this.form.fields.splice(index, 1);
            },
            closeForm () {
                this.$parent.showForm = false;
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const url = '/building/create';
                        this.formSubmitted = true;

                        api.post(url, this.form).then((resp) => {
                            this.$parent.buildings = Object.assign(
                                {},
                                this.$parent.buildings,
                                this.$parent.buildings.data.push(resp.data),
                            );

                            this.closeForm();
                            this.formSubmitted = false;
                        });
                    }
                });
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/buildings/BuildingForm.vue